import { inject } from "../ng";
import classes from "./footer.module.css";
import { MapLocation } from "./map-location";
import { MapMousePosition } from "./map-mouse-position";

export function Footer() {
	const year = new Date().getFullYear();
	const user = inject("UserProvider").getUser();
	return (
		<footer className={classes.footer}>
			<section className={classes.section}>
				<a href="https://maps.trimble.com/">&copy; {year} Trimble Maps</a>
				<a href="/terms">Terms</a>
				<a href="https://maps.trimble.com/privacy/">Privacy</a>
				<a href="https://support.copilotpro.com/en/support/home">Support</a>
			</section>
			<section className={classes.section}>
				<span>
					{user.userName} ({user.roles[0]}), {user.account}
				</span>
				<MapMousePosition />
				<MapLocation />
				<span>{user.gridDataVersion}</span>
			</section>
		</footer>
	);
}
